import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { Router } from '@angular/router';
import { SitFamModel } from './components/sitfam/models/sitfam.model';
import { DeclarationForm, DeclarationModel } from './models/declaration.model';
import { LogementModel } from './components/info-logement/models/logement.model';
import { PersonneModel } from './components/personne/models/personne.model';
import { ConstantePage } from '../constants/constante-page';
import { CcdLocaliteModel } from '@cnaf.usagers.appli/cnaf-commons-dral';
import { FormGroup } from '@angular/forms';
import { TagWaService } from '../services/tag-wa.service';
import { SimulerService } from '../services/simuler.service';
import { environment } from '../../environments/environment';
import { PageFinModel } from '../03-fin/models/pagefin.model';
import { log } from 'console';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html'
})
export class DeclarationComponent implements OnInit, AfterContentChecked {

  pageName = ConstantePage.STATS_PAGE_DECLARATION;
  chapter3Page = ConstantePage.STATS_CHAPTER3_PAGE_DECLARATION;
  sessionPageCourante: string;

  logementModel = new LogementModel(new CcdLocaliteModel(), '', '', '', '', null, null,null,null,null);
  sitFamModel = new SitFamModel();
  listePersonnes = new Array<PersonneModel>();
  declarationModel = new DeclarationModel(this.logementModel, this.sitFamModel, this.listePersonnes);
  pageFinModel = new PageFinModel ();

  isPageErreur = false;

  declarationForm = new FormGroup<DeclarationForm>({});

  estFinanceValue : string;

  /**
   * Constructor 
   * 
   * @param cd 
   * @param router 
   * @param tagWaService 
   */
  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly router: Router,    
    private readonly tagWaService: TagWaService,
    private readonly simulerService: SimulerService
  ) {}

  ngOnInit(): void {
    // On tague la page pour le WA
    this.tagWaService.tagPage(this.pageName, this.chapter3Page);
    
    // On recupère la page dans le session storage
    this.sessionPageCourante = sessionStorage.getItem(this.pageName);
    
    if (this.sessionPageCourante != null) {
      
      const json = JSON.parse(this.sessionPageCourante);
      this.declarationModel = new DeclarationModel(json.logement, json.sitFam, json.listePersonnes);      
      
      // InfosLogement
      this.logementModel = new LogementModel(
        json.logement.localite, 
        json.logement.lieuResidence, 
        json.logement.typeOccupation, 
        json.logement.typeCrous, 
        json.logement.estMeuble,
        json.logement.mttDeclare,
        json.logement.estConventionne,
        json.logement.datePrPrincipale,
        json.logement.estFinance,
        json.logement.mttMensualite);
      
      // SitFam
      this.sitFamModel.enCouple = json.sitFam.enCouple;
      this.sitFamModel.nbEnfants = json.sitFam.nbEnfants;
      
      this.listePersonnes = json.listePersonnes;
    }
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  /**
   * Récupération du bean logement 
   * @param $event LogementModel
   */
  recupererLogementModel($event : LogementModel) {
    this.logementModel = $event;
    this.declarationModel.logement = $event;
  }

  /**
   * Récupération des données associées aux personnes
   * @param $event 
   */
  recupererListePersonnes($event : Array<PersonneModel>) {
    this.listePersonnes = $event;
    this.declarationModel.listePersonnes = $event;
  }

  /**
   * Méthode déclenchée lorsque le composant SitFam renvoie un bean SitFam
   * @param $event type SitFamModel 
   */
  recupererSitFam($event : SitFamModel) {
    this.sitFamModel = $event;
    this.declarationModel.sitFam = $event;
  }

  /**
   * Click Suivant
   * - Récupérer le vrai objet declaration et le passer au service qui le stocke
   */
  clickSuivant() {
    
    if (this.logementModel.estFinance === 'false') {
     
      this.pageFinModel = new PageFinModel();
      this.pageFinModel.possedeDesDroits = false;
 
      sessionStorage.setItem("pageFinModel", JSON.stringify(this.pageFinModel));
      this.router.navigate(['/fin']);
    } else {
    sessionStorage.setItem(this.pageName, JSON.stringify(this.declarationModel));
    this.router.navigate(['/declaration-enfant']);
    }
  }
  
  async clickCalculer() {
    sessionStorage.setItem(this.pageName, JSON.stringify(this.declarationModel));
    
    if (environment.bouchon) {
      await this.simulerService.initBouchon();
    } else {
      await this.simulerService.initEcran();
    }   

    if (sessionStorage.getItem("erreurSimulateur")=="true") {
      this.isPageErreur = true;
    }

  }

}
